import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function TutorAccessPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error | expired
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`/api/auth/tutor-magic/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) {
          if (data.expiredAt) {
            setStatus('expired');
            setError(data.error);
          } else {
            setStatus('error');
            setError(data.error);
          }
        } else {
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          setStatus('success');
          // Courte pause pour afficher le message de succès puis rediriger
          setTimeout(() => { window.location.href = '/tutor'; }, 1200);
        }
      })
      .catch(() => {
        setStatus('error');
        setError('Erreur de connexion. Veuillez réessayer.');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 max-w-md w-full text-center">
        {/* Logo */}
        <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-6">
          <span className="text-white font-bold text-lg">S</span>
        </div>

        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Connexion en cours...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-xl font-semibold text-gray-800 mb-2">Connexion réussie</h1>
            <p className="text-gray-500 text-sm">Redirection vers votre espace tuteur...</p>
          </>
        )}

        {status === 'expired' && (
          <>
            <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="text-xl font-semibold text-gray-800 mb-2">Lien expiré</h1>
            <p className="text-gray-500 text-sm mb-4">{error}</p>
            <p className="text-gray-400 text-xs">
              Vous pouvez vous connecter directement avec votre email et mot de passe sur la page de connexion.
            </p>
            <a
              href="/login"
              className="mt-4 inline-block px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition-colors"
            >
              Se connecter
            </a>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-xl font-semibold text-gray-800 mb-2">Lien invalide</h1>
            <p className="text-gray-500 text-sm">{error}</p>
          </>
        )}
      </div>
    </div>
  );
}
